import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "border-b border-slate-200 px-4 py-4 sm:px-5"
};
const _hoisted_2 = {
  class: "flex items-start justify-between gap-3"
};
const _hoisted_3 = {
  class: "mt-1 text-sm text-slate-500"
};
const _hoisted_4 = {
  class: "min-h-0 flex-1 overflow-y-auto p-4 sm:p-5"
};
const _hoisted_5 = {
  class: "overflow-hidden rounded-lg border border-slate-200"
};
const _hoisted_6 = {
  class: "min-w-[640px] w-full divide-y divide-slate-200 text-sm"
};
const _hoisted_7 = {
  class: "divide-y divide-slate-100 bg-white"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  class: "px-3 py-2.5"
};
const _hoisted_10 = {
  class: "px-3 py-2.5 text-center"
};
const _hoisted_11 = ["onUpdate:modelValue"];
const _hoisted_12 = {
  class: "px-3 py-2.5"
};
const _hoisted_13 = ["onUpdate:modelValue"];
const _hoisted_14 = {
  class: "data-table-sticky-right data-table-sticky-action px-3 py-2.5 text-right"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["disabled"];
const _hoisted_17 = {
  class: "flex flex-col-reverse gap-3 border-t border-slate-200 px-4 py-4 sm:flex-row sm:justify-end sm:px-5"
};
const _hoisted_18 = ["disabled"];
const _hoisted_19 = ["disabled"];
import { computed, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { PlusIcon, TrashIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import AppModal from '@/components/AppModal.vue';
import { useWheelToHorizontalScroll } from '../composables/useWheelToHorizontalScroll';
import { preferencesForCustomer } from '../downstreamRules.mjs';
import { displayInvoiceCompanyName } from '../matrixRules.mjs';
export default {
  __name: 'InvoiceDownstreamTagPreferenceDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object,
      default: null
    },
    tags: {
      type: Array,
      default: () => []
    },
    preferences: {
      type: Array,
      default: () => []
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'submit'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const rows = ref([]);
    const tagPreferenceTableScrollRef = useWheelToHorizontalScroll();
    let nextLocalId = 1;
    const companyName = computed(() => props.customer ? displayInvoiceCompanyName(props.customer) : '-');
    const enabledTags = computed(() => [...(props.tags || [])].filter(tag => tag?.enabled !== false).sort((left, right) => {
      const leftOrder = Number(left?.displayOrder || 0);
      const rightOrder = Number(right?.displayOrder || 0);
      if (leftOrder !== rightOrder) return leftOrder - rightOrder;
      return String(left?.tagName || '').localeCompare(String(right?.tagName || ''), 'zh-CN');
    }));
    function resetRows() {
      const source = preferencesForCustomer(props.preferences, props.customer?.id);
      rows.value = source.map((item, index) => ({
        localId: nextLocalId++,
        tagId: item.tagId,
        priority: item.priority || index + 1,
        enabled: item.enabled !== false
      }));
    }
    function addRow() {
      const used = new Set(rows.value.map(row => String(row.tagId)).filter(Boolean));
      const first = enabledTags.value.find(tag => !used.has(String(tag.id)));
      rows.value.push({
        localId: nextLocalId++,
        tagId: first?.id || null,
        priority: rows.value.length + 1,
        enabled: true
      });
    }
    function removeRow(index) {
      rows.value.splice(index, 1);
    }
    function isTagUsed(tagId, ignoreIndex) {
      return rows.value.some((row, index) => index !== ignoreIndex && row.tagId != null && String(row.tagId) === String(tagId));
    }
    function close() {
      emit('update:modelValue', false);
    }
    function submit() {
      const normalized = [];
      const seen = new Set();
      for (const [index, row] of rows.value.entries()) {
        if (!row.tagId) {
          ElMessage.warning(`第 ${index + 1} 行请选择企业标签`);
          return;
        }
        if (seen.has(String(row.tagId))) {
          ElMessage.warning('偏好标签不能重复');
          return;
        }
        seen.add(String(row.tagId));
        normalized.push({
          tagId: row.tagId,
          priority: Number(row.priority || index + 1),
          enabled: row.enabled !== false
        });
      }
      emit('submit', {
        customer: props.customer,
        preferences: normalized
      });
    }
    watch(() => props.modelValue, value => {
      if (value) resetRows();
    });
    watch(() => [props.customer?.id, props.preferences], () => {
      if (props.modelValue) resetRows();
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.modelValue,
        size: "2xl",
        "z-index": 80,
        onClose: close
      }, {
        default: _withCtx(() => [_createElementVNode("header", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_cache[0] || (_cache[0] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "下游标签偏好", -1)), _createElementVNode("p", _hoisted_3, _toDisplayString(companyName.value) + " · 软评分规则，优先匹配但不保证命中。", 1)]), _createElementVNode("button", {
          type: "button",
          class: "rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
          onClick: close
        }, [_cache[1] || (_cache[1] = _createElementVNode("span", {
          class: "sr-only"
        }, "关闭", -1)), _createVNode(_unref(XMarkIcon), {
          class: "h-5 w-5"
        })])])]), _createElementVNode("main", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
          ref_key: "tagPreferenceTableScrollRef",
          ref: tagPreferenceTableScrollRef,
          class: "overflow-x-auto"
        }, [_createElementVNode("table", _hoisted_6, [_cache[3] || (_cache[3] = _createElementVNode("thead", {
          class: "bg-slate-50 text-left text-xs font-semibold text-slate-500"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "px-3 py-2.5"
        }, "偏好标签"), _createElementVNode("th", {
          class: "w-24 px-3 py-2.5 text-center"
        }, "启用"), _createElementVNode("th", {
          class: "w-28 px-3 py-2.5 text-right"
        }, "优先级"), _createElementVNode("th", {
          class: "data-table-sticky-right data-table-sticky-head data-table-sticky-action w-16 px-3 py-2.5 text-right"
        }, "操作")])], -1)), _createElementVNode("tbody", _hoisted_7, [rows.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[2] || (_cache[2] = [_createElementVNode("td", {
          colspan: "4",
          class: "px-3 py-8 text-center text-slate-500"
        }, "暂无标签偏好", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, index) => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.localId
          }, [_createElementVNode("td", _hoisted_9, [_createVNode(_component_el_select, {
            modelValue: row.tagId,
            "onUpdate:modelValue": $event => row.tagId = $event,
            filterable: "",
            class: "form-select form-control-sm w-full",
            placeholder: "选择企业标签"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(enabledTags.value, tag => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: tag.id,
                label: tag.tagName,
                value: tag.id,
                disabled: isTagUsed(tag.id, index)
              }, null, 8, ["label", "value", "disabled"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("td", _hoisted_10, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => row.enabled = $event,
            type: "checkbox",
            class: "form-check"
          }, null, 8, _hoisted_11), [[_vModelCheckbox, row.enabled]])]), _createElementVNode("td", _hoisted_12, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => row.priority = $event,
            type: "number",
            min: "1",
            step: "1",
            class: "form-input form-control-sm w-full text-right tabular-nums"
          }, null, 8, _hoisted_13), [[_vModelText, row.priority, void 0, {
            number: true
          }]])]), _createElementVNode("td", _hoisted_14, [_withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除",
            onClick: $event => removeRow(index)
          }, [_createVNode(_unref(TrashIcon), {
            class: "h-3.5 w-3.5"
          })], 8, _hoisted_15)), [[_directive_permission, 'enterprise-invoice:plan-customer:manage']])])]);
        }), 128))])])], 512)]), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-secondary mt-3 inline-flex w-full items-center justify-center gap-1.5 sm:w-auto",
          disabled: rows.value.length >= enabledTags.value.length,
          onClick: addRow
        }, [_createVNode(_unref(PlusIcon), {
          class: "h-4 w-4"
        }), _cache[4] || (_cache[4] = _createTextVNode(" 新增偏好 ", -1))], 8, _hoisted_16)), [[_directive_permission, 'enterprise-invoice:plan-customer:manage']])]), _createElementVNode("footer", _hoisted_17, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary w-full sm:w-auto",
          disabled: __props.submitting,
          onClick: close
        }, "取消", 8, _hoisted_18), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-primary w-full sm:w-auto",
          disabled: __props.submitting,
          onClick: submit
        }, [_createTextVNode(_toDisplayString(__props.submitting ? '保存中...' : '保存标签偏好'), 1)], 8, _hoisted_19)), [[_directive_permission, 'enterprise-invoice:plan-customer:manage']])])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};